export default __webpack_public_path__ + "static/media/cuerpo-mujer-piel-clara.c821bec0.png";